module.exports = __webpack_public_path__ + "img/Czech Republic.eb5bb814.svg";